<template>
    <div class="lesson-cloner overlay">
        <div class="panel" v-if="terms && paths">
            <div class="panel-heading">
                <h2>Copy Lesson <i @click="$parent.lessonToClone = null" class="fa fa-times"></i></h2>
            </div>
            <div class="panel-body">
                <form>
                    <h4 class="text-center">{{lesson.title}}</h4>
                    <div class="form-group">
                        <label>Term</label>
                        <select class="form-control" v-model="clone.term">
                            <option v-for="term in terms" :value="term">{{term.name}}</option>
                        </select>
                        <!-- <v-select :options="terms" v-model="clone.term" label="name" index="id"  /> -->
                    </div>
                    <div class="form-group" v-if="clone.term && courses">
                        <label>Course</label>
                        <select class="form-control" v-model="clone.instance">
                            <option v-for="course in courses" :value="course">{{course.courseName}}</option>
                        </select>
                        <!-- <v-select  :options="courses" v-model="clone.instance" label="courseName" index="id" /> -->
                    </div>
                    <div class="form-group">
                        <label>Week</label>
                        <select class="form-control" v-model="clone.week">
                          <option v-for="n in 16" :value="n">{{ n }}
                          </option>
                        </select>
                    </div>
                    <button @click.prevent="cloneLesson()" class="btn btn-success">Submit</button>
                        <!--    <select v-model="clone.term" class="form-control">
                            <option v-for="term in terms" :value="term.id">
                                {{term.name}}
                            </option>
                        </select> -->
             
                </form>
            </div>
        </div>
    </div>
</template>
<script>

import terms from '../../services/terms';
import courses from '../../services/courses';
import paths from '../../services/paths';
import videos from '../../services/videos';

import toastr from 'toastr';
import moment from 'moment';

export default {
    props: ['lesson'],
    data() {
        return {
            terms: null,
            courses:null,
            paths:null,
            courses:null,
            clone: {
                term: null,
                instance: null,
                week: null,
            }
        }
    },
    components: {

    },
    mounted() {
        this.getTerms();
        this.getPaths();

    },
    methods: {

        async cloneLesson() {

            const data = {
                courseId: this.clone.instance.associated.courseId,
                instanceId: this.clone.instance.id,
                oldInstanceId: this.lesson.instanceId,
                videoId: this.lesson.id,
                week: this.clone.week,
                termStartDate: this.clone.term.startDate
            }

            videos.clone(data).then((response)=> {
                if (response.data.success === true) {
                    toastr.success('Lesson cloned');
                    this.$parent.lessonToClone = null
                } else {
                    toastr.error(response.data.message);
                }
            })
        },
        selectCourses() {
            if (!this.clone.term) return;
            this.courses = null;
            this.courses = this.clone.term.instances.map((i)=> {
                i.courseName = i.associated.name;                
                const coursePaths = this.paths.filter((p) => p.courses.includes(i.associated.id));
                if (coursePaths.length) {
                    i.courseName = coursePaths.map(p =>p.name).join(', ')+ ' - ' + i.courseName;
                }
                
                return i;
            }).sort((a, b) => { return a.courseName.localeCompare(b.courseName) });
        },
        getPaths() {
            paths.getPaths().then((response)=> {                
                this.paths = response;
            });
        },

        getCourses() {
            // courses.getAll().then((response) => {
            //     this.courses  = response.data.courses.map((c)=> {
            //         const path = this.paths.find(p => p.courses.includes(c.id));
            //         if (path) c.name = path.name + ' - ' + c.name;
            //         return c; 
            //     }).sort((a, b) => { return a.name.localeCompare(b.name) });
            // });
        },
 
        getTerms() {
            terms.get().then((response) => {
                const nextTerm = moment().add(3,'months');
                this.terms = response.data.terms
                .filter((t)=>{
                    return new Date(t.startDate) < nextTerm;
                })
                .sort((a, b) => {
                    return new Date(b.startDate) - new Date(a.startDate);
                });
            });
        }
    },
    watch: {
        selectedTerm() {
            this.selectCourses();
        },
    },
    computed: {
        selectedTerm() {
            console.log()
            if (this.clone.term) return this.clone.term.id
        }
    }
}

</script>
<style lang="scss">
.lesson-cloner {
    button,
    .selected-tag {
        color: #fff!important;
    }
    i::before {
        border-color:#fff!important;
    }
    input.form-control {
        border:none!important;
    }

}

</style>
<style lang="scss" scoped>
h2 {
    display: flex;
    align-items: center;
    justify-content: space-between;

    i {
        cursor: pointer;
    }
}

.panel {
    width: 500px;
    .form-group {
        margin-bottom:1rem;
    }

    .panel-body {
        padding: 1rem;
    }
}

.overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    background: rgba(0, 0, 0, .7);
    display: flex;
    align-items: center;
    justify-content: center;
}

</style>



// WEBPACK FOOTER //
// LessonCloner.vue?4ef783f7